import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppFloat = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Show the button after a short delay for better UX
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    // Show tooltip after 3 seconds to encourage interaction
    const tooltipTimer = setTimeout(() => {
      setShowTooltip(true);
      // Hide tooltip after 5 seconds
      setTimeout(() => setShowTooltip(false), 5000);
    }, 3000);

    return () => {
      clearTimeout(timer);
      clearTimeout(tooltipTimer);
    };
  }, []);

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/27763296351?text=Hi%2C%20I%27d%20like%20to%20inquire%20about%20freight%20forwarding%20services', '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="whatsapp-float">
      {/* Tooltip */}
      {showTooltip && (
        <div 
          className="absolute bottom-20 right-0 bg-white text-slate-900 px-4 py-3 rounded-lg shadow-xl border border-slate-200 whitespace-nowrap animate-in slide-in-from-bottom-4 fade-in"
          style={{ minWidth: '200px' }}
        >
          <button
            onClick={() => setShowTooltip(false)}
            className="absolute -top-2 -right-2 w-6 h-6 bg-slate-900 text-white rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors"
          >
            <X className="w-3 h-3" />
          </button>
          <p className="text-sm font-medium mb-1">Need help?</p>
          <p className="text-xs text-slate-600">Chat with us on WhatsApp!</p>
        </div>
      )}

      {/* WhatsApp Button */}
      <button
        onClick={handleWhatsAppClick}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setTimeout(() => setShowTooltip(false), 2000)}
        data-testid="whatsapp-button"
        className="group relative w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 flex items-center justify-center animate-in zoom-in"
        aria-label="Chat on WhatsApp"
      >
        {/* Pulsing ring animation */}
        <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-75"></span>
        
        {/* Icon */}
        <MessageCircle className="w-8 h-8 relative z-10 group-hover:scale-110 transition-transform duration-300" />
      </button>
    </div>
  );
};

export default WhatsAppFloat;
